import MySideMenu from '@/components/common/sideMenu/MySideMenu.vue'

import MMP_AM_001 from '@/views/mp/MMP_AM_001.vue'
import MMP_AM_002 from '@/views/mp/MMP_AM_002.vue'
import MMP_AM_003 from '@/views/mp/MMP_AM_003.vue'

import EmptyLayout from '@/layoutPage/EmptyLayout.vue'
//user관련 | My Page 화면 라우터
const usertRouter = [
     
    /* 화면명 : 임시저장함  : MMP_AM_001  */
    {
        path: "/mp/MMP_AM_001", 
        name : 'MMP_AM_001',
        components: {
            default : MMP_AM_001,
            sideMenu : MySideMenu
        },
        meta :{
            title: '임시저장함',
            IADepth: ['MyPage', '임시저장함']
        }
    },

     
    /* 화면명 : 알람조회  : MMP_AM_002  */
    {
        path: "/mp/MMP_AM_002", 
        name : 'MMP_AM_002',
        components: {
            default : MMP_AM_002,
            sideMenu : MySideMenu
        },
        meta :{
            title: '알람조회',
            IADepth: ['MyPage', '알람조회']
        }
    },

    /* 화면명 : 개인정보변경  : MMP_AM_003  */
    {
        path: "/mp/MMP_AM_003", 
        name : 'MMP_AM_003',
        components: {
            default : MMP_AM_003,
            sideMenu : MySideMenu
        },
        meta :{
            title: '개인정보변경',
            IADepth: ['MyPage', '개인정보변경']
        }
    },

    /* 화면명 :  아이디 찾기  : PCM_AM_001  */
    {
        path: "/MP/PCM_AM_001", 
        name : 'PCM_AM_001',
        component: () => import('@/views/mp/PCM_AM_001.vue'),
        meta:{
            layout : EmptyLayout,
            notReqLogin : true,
        }
    },

    /* 화면명 : 비밀번호 찾기  : PCM_AM_002  */
    {
        path: "/MP/PCM_AM_002", 
        name : 'PCM_AM_002',
        component: () => import('@/views/mp/PCM_AM_002.vue'),
        meta:{
            layout : EmptyLayout,
            notReqLogin : true,
        }
    },


]
export{usertRouter}